module.exports = __webpack_public_path__ + "static/img/15bg_2.f87a003.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_2.png
// module id = 651
// module chunks = 1